import css from 'styled-jsx/css';
import { display, serif } from 'styles/css-constants';
import { MQ_MEDIUM, MQ_LARGE } from 'constants/mq';
import { sharedPalette } from 'styles/colors/constants';

const { atRed } = sharedPalette;

export default css`
  .Faq {
    margin-bottom: 1rem;
  }

  h3 {
    font-size: var(--fontScale2);
    font-weight: bold;
    font-family: ${display};
    line-height: 1.4;
    margin-bottom: 0.1rem;
  }

  h3 a {
    color: #000;
    display: flex;
    align-items: flex-start;
  }

  h3 a span.Faq__pos {
    flex: 0 0 1.75rem;
  }

  h3 span.Faq__pos {
    margin-right: 0.5rem;
    color: #767676;
  }

  .Faq__partnerLabel {
    font-size: var(--fontScaleNeg2);
    color: ${atRed};
    text-transform: uppercase;
    margin-left: 2.25rem;
    margin-bottom: 0.25rem;
  }

  .Faq__items {
    margin: 1.25rem 0 1.75rem;
    max-width: 800px;
    padding-left: 2.25rem;
    color: #333;
  }

  .Faq__item {
    margin-bottom: 1rem;
  }

  @media screen and ${MQ_MEDIUM} {
    h3 {
      font-weight: normal;
    }

    .Faq__items {
      max-width: 730px;
    }

    .Faq__partnerLabel {
      font-size: var(--fontScaleNeg1);
    }
  }

  @media screen and ${MQ_LARGE} {
    h3 a span {
      flex: 0 0 2.25rem;
    }

    .Faq__items {
      margin-bottom: 3rem;
      padding-left: 2.75rem;
    }
  }
`;

export const globalStyles = css.global`
  .Faq__items p,
  .Faq__items ul,
  .Faq__items h4 {
    font-family: ${serif};
  }

  .Faq__items h4 {
    font-size: 24px;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  .Faq__items p,
  .Faq__items ul {
    font-size: 18px;
    line-height: 1.5em;
    margin-bottom: 1em;
  }

  .Faq__items ul {
    list-style: outside;
    padding-left: 1em;
  }

  @media screen and ${MQ_MEDIUM} {
    .Faq__items p,
    .Faq__items ul {
      font-size: 1.2em;
    }
  }
`;
